export const getBuyerProtectionDuration = (code?: string | null): number => {
    switch (code) {
        case 'ENHANCED_BUYER_PROTECTION_7_DAY':
            return 7;
        case 'ENHANCED_BUYER_PROTECTION_30_DAY':
            return 30;
        case 'ENHANCED_BUYER_PROTECTION_60_DAY':
            return 60;
        case 'ENHANCED_BUYER_PROTECTION_90_DAY':
            return 90;
        default:
            // default buyer protection duration is 7 days for everyone, excluding trade users
            return 7;
    }
};
